import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["min", "max", "minOutput", "maxOutput", "track"]
  static values = { floor: Number, ceiling: Number }

  connect() {
    this.render()
  }

  updateMin() {
    if (Number(this.minTarget.value) > Number(this.maxTarget.value)) {
      this.minTarget.value = this.maxTarget.value
    }
    this.render()
  }

  updateMax() {
    if (Number(this.maxTarget.value) < Number(this.minTarget.value)) {
      this.maxTarget.value = this.minTarget.value
    }
    this.render()
  }

  render() {
    const min = Number(this.minTarget.value)
    const max = Number(this.maxTarget.value)
    const span = this.ceilingValue - this.floorValue || 1

    this.minOutputTarget.textContent = this.format(min)
    this.maxOutputTarget.textContent = this.format(max)
    this.trackTarget.style.setProperty("--range-start", `${((min - this.floorValue) / span) * 100}%`)
    this.trackTarget.style.setProperty("--range-end", `${((max - this.floorValue) / span) * 100}%`)
  }

  format(value) {
    if (this.minTarget.name.startsWith("price_")) {
      return new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 }).format(value)
    }
    if (this.minTarget.step.includes(".")) {
      return value.toFixed(1)
    }
    return new Intl.NumberFormat("en-US", { maximumFractionDigits: 0 }).format(value)
  }
}
